import Axios from "axios";
export default Axios.create({
  // baseURL: "http://43.204.25.102:5000",
  baseURL: "https://api.microstudy.in",
  // baseURL: " http://103.163.126.246:3300",
  // baseURL: "http://localhost:3300",
});

// prod url
// base url
// hgfgh
